import React from "react";
import {css, Theme} from "@emotion/react";

import {listUnStyled, mb, mh, mv, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {getVendorPromotions} from "../../helpers/get_vendor_promotions";
import {IVendorDetailPromotion, VendorDetailPromotionBox} from "./boxes/VendorDetailPromotionBox";

interface IProps {
    promotions: IVendorDetailPromotion[];
    vendorSlug: string;
}

export const VendorDetailPromotions = (props: IProps) => {
    const {promotions} = props;
    const renderPromotions = getVendorPromotions({promotions});

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(4), onDesktop(mb(6))]}>
                Oferty Specjalne
            </Text>

            <ul css={[listUnStyled]}>
                {renderPromotions.map((promotion) => (
                    <li key={promotion.id} css={vendorDetailPromotionsListElementStyle}>
                        <VendorDetailPromotionBox promotion={promotion} vendorSlug={props.vendorSlug} />
                    </li>
                ))}
            </ul>
        </>
    );
};

const vendorDetailPromotionsListElementStyle = (theme: Theme) => css`
    max-width: 375px;
    ${mh("auto")};
    ${mv(1.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: unset;
        ${mv(3)};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {listUnStyled, mb, mh, mv, onDesktop} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {getVendorPromotions} from "../../helpers/get_vendor_promotions";
import {IVendorDetailPromotion, VendorDetailPromotionBox} from "./boxes/VendorDetailPromotionBox";

interface IProps {
    promotions: IVendorDetailPromotion[];
    vendorSlug: string;
}

export const VendorDetailPromotions = (props: IProps) => {
    const {promotions} = props;
    const renderPromotions = getVendorPromotions({promotions});

    return (
        <>
            <Text as="h2" variant="headline_3" css={[mb(4), onDesktop(mb(6))]}>
                Oferty Specjalne
            </Text>

            <ul css={[listUnStyled]}>
                {renderPromotions.map((promotion) => (
                    <li key={promotion.id} css={vendorDetailPromotionsListElementStyle}>
                        <VendorDetailPromotionBox promotion={promotion} vendorSlug={props.vendorSlug} />
                    </li>
                ))}
            </ul>
        </>
    );
};

const vendorDetailPromotionsListElementStyle = (theme: Theme) => css`
    max-width: 375px;
    ${mh("auto")};
    ${mv(1.5)};

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: unset;
        ${mv(3)};
    }
`;
